import { useEffect, useState, Suspense } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ProfilePageClient from '../profile/ProfilePageClient';
import { checkProfileDataExists } from '../lib/actions/linkedin';

function ProfilePageLoading() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <div className="text-slate-600">Loading profile...</div>
      </div>
    </div>
  );
}

export default function ProfilePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const accessToken = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');
    const tokenFromUrl = searchParams.get('_token');

    // If tokens are present, redirect to API route to process them
    if (accessToken) {
      const callbackParams = new URLSearchParams({
        access_token: accessToken,
        ...(refreshToken && { refresh_token: refreshToken }),
        redirect: '/profile',
      });

      // Preserve all other query params except access_token and refresh_token
      searchParams.forEach((value, key) => {
        if (key !== 'access_token' && key !== 'refresh_token') {
          callbackParams.append(key, value);
        }
      });

      navigate(`/api/auth/callback?${callbackParams.toString()}`);
      return;
    }

    // If we have a token, check if profile data exists
    if (tokenFromUrl) {
      checkProfileDataExists(tokenFromUrl)
        .then((profileDataExists) => {
          if (!profileDataExists) {
            navigate('/agent/waitlist');
          } else {
            setIsLoading(false);
          }
        })
        .catch(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [searchParams, navigate]);

  if (isLoading) {
    return <ProfilePageLoading />;
  }

  return (
    <Suspense fallback={<ProfilePageLoading />}>
      <ProfilePageClient />
    </Suspense>
  );
}
